const reportKey = {
  campaigns: 'campaigns',
};

export const campaignsReqTypes = {
  base: reportKey.campaigns,
};

export default campaignsReqTypes;
